import { Api, ApiUrl } from "../../services";
import { mutations as MUTATION, actions as ACTION } from "./types";

const actions = {
  [ACTION.FETCH_SHOP_LIST_AGENCY]: async (store, { type, reFetch = false }) => {
    const { state } = store;
    try {
      if (!state[type].fetched || reFetch) {
        state.shopList.status.loading = true;
        // await new Promise((resolve) => {
        //   setTimeout(() => {
        //     resolve();
        //   }, 50000);
        // })
        const res = await Api.base.get(ApiUrl.base.agency[type]);
        state.shopList.status.loading = false;
        if (res && res.data && res.data.shops) {
          store.commit(MUTATION.AGENCY_FETCH_SHOP_LIST, {
            shops: res.data.shops,
            type: type
          });
        }
      }
      state[type].fetched = true;
    } catch (error) {
      state.shopList.status.loading = false;
      state[type].fetched = true;
    }
  },
  [ACTION.UPDATE_SHOP_PAGINATION_AGENCY]: (store, page) => {
    store.commit(MUTATION.AGENCY_UPDATE_SHOP_PAGINATION, page);
  },
  [ACTION.LOGIN_SHOP_AGENCY]: async (store, shop) => {
    const state = store.state;
    try {
      state.shopLogStatus.loading = true;
      if (process.env.NODE_ENV == "development") {
        let delay = new Promise((resolve) => {
          setTimeout(() => {
            resolve();
          }, 1500);
        });
        await delay;
      }
      const res = await Api.base.get(ApiUrl.base.agency.loginShop(shop.id));
      if (res && res.status) {
        var url = window.location.href;
        var arr = url.split("/");
        var destination = arr[0] + "//" + arr[2] + "/admin/dashboard";
        window.location.href = destination;
      }
    } catch (error) {
      state.shopLogStatus.loading = false;
      state.shopLogStatus.error = true;
      return error;
    }
  },
  [ACTION.LOGIN_SHOP_FROM_AGENCY]: async (store, shop) => {
    const state = store.state;
    try {
      state.shopLogStatus.loading = true;
      if (process.env.NODE_ENV == "development") {
        let delay = new Promise((resolve) => {
          setTimeout(() => {
            resolve();
          }, 1500);
        });
        await delay;
      }
      const res = await Api.base.get(ApiUrl.base.agency.loginShop(shop.id));
      if (res && res.status) {
        var url = window.location.href;
        var arr = url.split("/");
        var destination = arr[0] + "//" + arr[2] + "/dashboard";
        window.open(destination, "_blank");
        state.shopLogStatus.loading = false;

        // window.location.href = destination;
      }
    } catch (error) {
      state.shopLogStatus.loading = false;
      state.shopLogStatus.error = true;
      return error;
    }
  },
  [ACTION.GET_AGENCY]: async store => {
    const state = store.state;
    try {
      if (process.env.NODE_ENV == "development") {
        let delay = new Promise((resolve) => {
          setTimeout(() => {
            resolve();
          }, 1500);
        });
        await delay;
      }
      const res = await Api.base.get(ApiUrl.base.agency.me());
      if (res && res.data.status) {
        state.info = res.data.agency;
        state.logged = true;
      }
    } catch (e) {
      store;
    }
    state.fetched = true;
  },
  [ACTION.UNLINK_SHOP_AGENCY]: async (store, shop) => {
    const state = store.state;
    state.shopUnlinkStatus.loading = true;
    try {
      let method = process.env.NODE_ENV == "development" ? "get" : "post";
      let res = await Api.base[method](ApiUrl.base.agency.unlink(shop));
      if (process.env.NODE_ENV == "development") {
        let delay = new Promise((resolve) => {
          setTimeout(() => {
            resolve();
          }, 50000);
        });
        await delay;
      }

      if (res && res.data.status) {
        state.shopUnlinkStatus.loading = false;
        state.shopUnlinkStatus.success = true;
        store.commit(MUTATION.AGENCY_UNLINK_SHOP, { shop });
        setTimeout(() => {
          state.shopUnlinkStatus.loading = false;
          state.shopUnlinkStatus.success = false;
        }, 1500);
        Promise.resolve(res.data);
      } else {
        throw res;
      }
    } catch (error) {
      state.shopUnlinkStatus.loading = false;
      state.shopUnlinkStatus.error = true;
      setTimeout(() => {
        state.shopUnlinkStatus.loading = false;
        state.shopUnlinkStatus.error = false;
      }, 1500);
      return Promise.reject(error);
    }
  },
  [ACTION.UPDATE_AGENCY_INFO_AGENCY]: async (store, data) => {
    // const state = store.state;
    store.commit(MUTATION.AGENCY_UPDATE_STATUS, {
      loading: true
    });
    let method = process.env.NODE_ENV == "development" ? "get" : "post";
    Api.base[method](ApiUrl.base.agency.updateAgencyInfo, data)
      .then(() => {
        store.commit(MUTATION.AGENCY_UPDATE_STATUS, {
          success: true
        });
        store.commit(MUTATION.AGENCY_UPDATE_AGENCY_INFO, data);
        setTimeout(() => {
          store.commit(MUTATION.AGENCY_UPDATE_STATUS, {
            success: false
          });
        }, 2000);
      })
      .catch(() => {
        store.commit(MUTATION.AGENCY_UPDATE_STATUS, {
          error: true
        });
        setTimeout(() => {
          store.commit(MUTATION.AGENCY_UPDATE_STATUS, {
            error: false
          });
        }, 2000);
      });
  },
  [ACTION.UPDATE_AGENCY_PASSWORD_AGENCY]: (store, data) => {
    // const state = store.state;
    store.commit(MUTATION.AGENCY_UPDATE_STATUS, {
      loading: true
    });
    let method = "post" //process.env.NODE_ENV == "development" ? "get" : "post";
    return new Promise(async (resolve, reject) => {
      try {
        let res = await Api.base[method](ApiUrl.base.agency.updatePassword, data);
        if (res.data.status == true || res.data.status == "success") {
          store.commit(MUTATION.AGENCY_UPDATE_STATUS, {
            success: true
          });
          setTimeout(() => {
            store.commit(MUTATION.AGENCY_UPDATE_STATUS, {
              success: false
            });
          }, 2000);
          resolve(res.data);
        } else {
          throw res;
        }
      } catch (err) {
        store.commit(MUTATION.AGENCY_UPDATE_STATUS, {
          error: true
        });
        setTimeout(() => {
          store.commit(MUTATION.AGENCY_UPDATE_STATUS, {
            error: false
          });
        }, 2000);
        reject(err);
      }
    });
  },
  [ACTION.SIGN_OUT_AGENCY]: async () => {
    let method = process.env.NODE_ENV == "development" ? "get" : "delete";
    try {
      let res = await Api.base[method](ApiUrl.base.agency.signout);
      if (res.data && res.data.status) {
        return Promise.resolve(res.data);
      } else {
        throw res.data;
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  [ACTION.CHECK_LINKED_AGENCY]: async (store, shop_id) => {
    try {
      let res = await Api.base(ApiUrl.base.agency.isLinked(shop_id));
      if(res.data && res.data.status) {
        if(res.data.linked) {
          throw res.data;
        }
        return Promise.resolve(res.data);
      } else {
        throw res.data;
      }
    } catch(error) {
      return Promise.reject(error);
    }
  },
  [ACTION.UPLOAD_IMAGE_AGENCY]: async (store, {data, config, onSuccess, onError}) => {
    try {
      let method = process.env.NODE_ENV == "development" ? "get" : "post";
      let res = await Api.base[method](
        ApiUrl.base.agency.uploadImage,
        { file: data },
        config
      );

      if (res.data) {
        // this.$emit("loaded", res.data.url, this.index);
        if (onSuccess) onSuccess(res);
      } else {
        throw res;
      }
    } catch (err) {
      if (onError) {
        if (err.data) onError(err.data);
        else onError(err.message);
      }
    }
  },
  [ACTION.OPEN_SWITCH_AGENCY_MODAL]: (store) => {
    const { state } = store;
    state.isOpenSwitchModal = true
  },
  [ACTION.CLOSE_SWITCH_AGENCY_MODAL]: (store) => {
    const { state } = store;
    state.isOpenSwitchModal = false
  }
};

export default actions;
